<template>
 <tab-page-template>
   <template #toolbar-items>
     <v-toolbar-title class="with-divider">
       サービスプロファイル閲覧
     </v-toolbar-title>
   </template>

   <owner-info
       v-if="!isOwnedServiceProfile"
       :account="account"
       show-detail>
   </owner-info>

   <v-container fluid>
     <service-profile-info
       :service-profile-view="serviceProfile">
     </service-profile-info>
   </v-container>

   <template #tab-items>
     <v-tab>プロセスプロファイル</v-tab>
     <v-tab-item>
       <process-profile-tab :service-profile-id="serviceProfileId"></process-profile-tab>
     </v-tab-item>

     <v-tab>イベントプロファイル</v-tab>
     <v-tab-item>
       <event-profile-tab :service-profile="serviceProfile"></event-profile-tab>
     </v-tab-item>
   </template>
 </tab-page-template>
</template>

<script>
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import OwnerInfo from "@/components/organisms/OwnerInfo.vue";
import {mapGetters} from "vuex";
import IoablePageMixin from "@/router/IoablePageMixin";
import ProcessProfileTab from "@/components/pages/profile/ProfileManagement/ServiceProfile/ProcessProfileTab.vue";
import EventProfileTab from "@/components/pages/profile/ProfileManagement/ServiceProfile/EventProfileTab.vue";
import ServiceProfileSource from "@/components/organisms/ServiceProfileSource";
import ServiceProfileInfo from "@/components/organisms/ServiceProfileInfo.vue";
import {safeMeta} from "@/router/Meta";

export default {
  name: "ServiceProfile",
  components: {
    ServiceProfileInfo,
    EventProfileTab, ProcessProfileTab, OwnerInfo, TabPageTemplate},
  mixins: [IoablePageMixin, ServiceProfileSource],
  props: {
    serviceProfileId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      serviceProfile: {
        id: this.serviceProfileId
      },
    }
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account'
    }),
    isOwnedServiceProfile() {
      return safeMeta(this.$route).isOwnedServiceProfile ?? false;
    },
    ownerInfo() {
      if(this.isOwnedServiceProfile) {
        return this.account;
      } else {
        const dp = this.serviceProfile;
        return {
          ownerId: dp.ownerId,
          ownerName: dp.ownerName,
          terminalId: dp.terminalId,
          terminalName: dp.terminalName,
        };
      }
    },
  },
  methods: {
    async load() {
      this.serviceProfile = await this.loadServiceProfile(this.serviceProfileId);
    }
  },
}
</script>

<style scoped>

</style>
